import React, { useState } from 'react'
import { DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";
import ActionSend from "./bulk-actions/ActionSend"

const BulkActions = (props) => {
    const [isOpen, setIsOpen] = useState(false)
    const [showModalUpdateSewing, setShowModalUpdateSewing] = useState(false)
    const [open, setOpen] = useState(false)
    const [isForceModal, setIsForceModal] = useState(false)

    const _showModal = () => {
        setIsOpen(true)
    }

    const _closeModal = () => {
        setIsOpen(false)
    }

    const onCloseModalUpdateSewing = () => {
        setShowModalUpdateSewing(false)
    }

    const onshowModalUpdateSewing = () => {
        setShowModalUpdateSewing(true)
    }

    const _showModal2 = () => {
        setOpen(true)
    }

    const _hideModal = () => {
        setOpen(false)
    }

    const handleChangeForceModal = (isOpen = false) => {
        setIsForceModal(isOpen)
    }

    return (
        <UncontrolledDropdown className='MenuActions'>
            <DropdownToggle tag='span' className='ToggleActions'>
                <span
                    className='border rounded d-inline-flex px-2 py-1 bg-light font-weight-normal align-items-baseline'>
                    Hành động <i className="fa fa-caret-down ml-2" />
                </span>
            </DropdownToggle>

            <DropdownMenu>
                <ActionSend
                    {...props}
                    isOpen={isOpen}
                    showModal={_showModal}
                    closeModal={_closeModal}
                    showModalUpdateSewing={showModalUpdateSewing}
                    onCloseModalUpdateSewing={onCloseModalUpdateSewing}
                    onshowModalUpdateSewing={onshowModalUpdateSewing}
                    onShowModal2={_showModal2}
                    onHideModal={_hideModal}
                    open={open}
                    onChangeForceModal={handleChangeForceModal}
                    isForceModal={isForceModal}
                />
            </DropdownMenu>
        </UncontrolledDropdown>
    )
}

export default BulkActions
